import React from "react";
import { PathConstant } from "const";

const NotFound = () => {
  return (
    <div
      style={{
        padding: "16px",
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <h3 style={{ marginBottom: "16px" }}>404</h3>
        <h5 style={{ marginBottom: "16px" }}>The page you are looking for isn't here</h5>
        <small style={{ display: "block", marginBottom: "16px" }}>
          You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation.
        </small>
        <a href={PathConstant.BRANCH_MANAGEMENT} className="btn btn-primary">
          Go Back
        </a>
      </div>
    </div>
  );
};

export default NotFound;
